module.exports = __webpack_public_path__ + "img/sos.ff7f4c8d.svg";